<template>
  <div>
    <v-row>
      <!-- 대출 모집중일 때 -->
      <v-col v-if="investingPullRevenue">
        <router-link
          style="text-decoration: none; color: inherit"
          :to="{ path: `loan/${investingPullRevenue.uuid}/investing` }"
        >
          <h4 class="mb-2">미래매출 당겨받기 모집 현황</h4>
          <v-progress-linear
            :value="isContractable ? 100 : investingPercent"
            color="primary"
            :height="isExecuting || isContractable ? 52 : 25"
            rounded
          >
            <template v-slot:default>
              <strong class="white--text">
                <template v-if="isExecuting">대출금 송금 준비중</template>
                <template v-else-if="isContractable">모집 완료! 계약서 작성하러 가기</template>
                <template v-else>{{ commaFormat(investingAmount) }} 원</template>
              </strong>
            </template>
          </v-progress-linear>
        </router-link>
      </v-col>

      <!-- 모집중인 대출 없을 때 -->
      <v-col class="mt-0" v-else-if="isPullRevenueOfferRequest">
        <BasicButton class="basic-button--apply"
        header="2~5일 매출을 바로 사용하고 조금씩 일상환"
        footer="제휴 금융사인 펀다가 제공합니다"
         @click="moveToLoan">
          {{ isEarlyPaymentEnabled ? '미래매출 당겨받기' : '비상금 대출' }}
        </BasicButton>
      </v-col>

      <!-- 대출 실행 완료 후 -->
      <v-col class="mt-0" v-else-if="executedPullRevenue">
        <BasicButton
          class="basic-button--apply"
          header="2~5일 매출을 바로 사용하고 조금씩 일상환"
          footer="제휴 금융사인 펀다가 제공합니다"
          :to="{ name: 'loan/repayment', params: { uuid: executedPullRevenue.uuid } }"
        >
        {{ isEarlyPaymentEnabled ? '미래매출 당겨받기' : '비상금 대출' }} 이용내역
        </BasicButton>
      </v-col>
    </v-row>

    <!-- 우리동네 크라우드 펀딩 버튼 -->
    <v-row class="mb-2" v-if="showWooriCrowdButton">
      <v-col class="mt-0">
        <BasicButton
          class="basic-button--apply"
          @click="moveToWooriCrowd(false)"
          header="정책자금으로 이자와 수수료를 모두 페이백!"
          footer="제유 금융사인 펀다가 제공합니다"
          v-if="mode !== 'production'"
        >
          우리동네 크라우드 펀딩
        </BasicButton>
        <BasicButton
          class="basic-button--apply"
          @click="moveToWooriCrowd(true)"
          header="정책자금으로 이자와 수수료를 모두 페이백!"
          footer="제유 금융사인 펀다가 제공합니다"
          v-else
        >
          우리동네 크라우드 펀딩
        </BasicButton>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { defaultApi } from '@/plugins/api/defaultApi'
import { commaFormat } from '@/filter/number'

export default {
  name: 'LoanButtons',
  components: {
    BasicButton: () => import('@/components/common/button/BasicButton.vue'),
  },
  data() {
    return {
      investingAmount: 0,
    }
  },
  computed: {
    ...mapState('env', ['mode']),
    ...mapState('contract', {
      contractCurrent: 'current',
    }),
    ...mapGetters('loan', [
      'isPullRevenueOfferRequest',
      'investingPullRevenue',
      'executedPullRevenue',
    ]),
    isEarlyPaymentEnabled() {
      return (
        this.contractCurrent?.status === 'started' &&
        this.contractCurrent?.isEarlyPaymentEnabled === true
      )
    },
    showWooriCrowdButton() {
      return true
      // return false
    },
    investingPercent() {
      if (!this.investingPullRevenue || !this.investingAmount) return 0
      return ((this.investingAmount / this.investingPullRevenue.amount) * 100).toFixed(0)
    },
    isExecuting() {
      return this.investingPullRevenue?.status === 'executing'
    },
    isContractable() {
      if (
        !this.investingPullRevenue ||
        !['investing', 'invested'].includes(this.investingPullRevenue.status) ||
        this.investingAmount < 1
      ) {
        return false
      }

      const now = this.$moment()
      const start = this.$moment(this.investingPullRevenue.contractStartTime)
      const end = this.$moment(this.investingPullRevenue.contractEndTime)
      return now.isSameOrAfter(start) && now.isBefore(end)
    },
  },
  methods: {
    ...mapActions('evaluation', ['isKcsAgreements', 'isHometaxAccounts']),
    commaFormat,
    async moveToLoan() {
      this.$emit('show-transition', '/loan/pull-revenue')
    },
    moveToWooriCrowd(isProduction) {
      const route = {
        name: 'woori-crowd',
      }
      
      if (!isProduction) {
        route.query = { autoRedirect: false }
      }
      
      this.$emit('show-transition', route)
    },
  },
  watch: {
    investingPullRevenue: {
      immediate: true,
      async handler(v) {
        if (!v) return
        const { data } = await defaultApi.getInvestingAmount(v.uuid)
        this.investingAmount = data || 0
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.basic-button--apply {
  background-color: #4163d5 !important;
  color: #ffe15b !important;
  // border-radius: 10px;
  border-radius: 1px;
}
</style> 